import Crud from '../views/DispatchType/Crud'
import Entity from '../views/DispatchType/Add'

let routes = {
    path: '/dispatch_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/dispatch_types/add',
            name: 'NewDispatchType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Despacho',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Despacho',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/dispatch_types/edit/:id?',
            name: 'EditDispatchType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Despacho',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Tipo de Despacho',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/dispatch_types',
            name: 'list-dispatch-types',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Despachos',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Tipos de Despachos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
